<td-message
  *ngIf="isError; else showWarning"
  label="Error!"
  sublabel="{{ params.message }}"
  color="warn"
  icon="error"
></td-message>
<ng-template #showWarning>
  <td-message
    label="Warning!"
    sublabel="{{ params.message }}"
    color="primary"
    icon="warning"
  ></td-message>
</ng-template>
